export interface FixedHeaderConfig {
    element: HTMLElement;
}

export class FixedHeader {
    private readonly element: HTMLElement;

    constructor({element}: FixedHeaderConfig) {
        this.element = element;
        this.init();
    }

    protected onScroll(): void {
        let scrolled = (window.pageYOffset > this.element.clientHeight);
        scrolled
            ? this.element.classList.add(`is-fixed`)
            : this.element.classList.remove(`is-fixed`);
    }

    protected init(): void {
        if (!this.element) return;
        window.addEventListener('scroll', () => this.onScroll());
    }
}